<template>
  <div :class="['transport-view', isApplicationAuto ? 'application-auto-transport' : '']">

    <div v-if='!isApplicationAuto' class="transport-view-header">

      <div class="field-label">Транспорт:</div>

      <div class="transport-tabs">

        <div
          v-for='(transport, index) in transports'
          :key='transport.id'
          :class="['tab',
            currentTransportIndex === index ? 'tab-active' : '',
            transport.access == 1 ? 'tab-blocked' : '',
            transport.trailer !== '' ? 'marquee' : ''
          ]"
          @click='selectTransport(index, transport.files)'
        >

          <div
            :class="['tab-text', transport.trailer !== '' ? 'marquee-inner' : '']"
            :title="tabTitle(transport)"
          >
            <div
              class='transport-tab-text'
            >
              <img :src="`${baseUrl}/img/icons/${transport.numberNationality.iso2}.svg`" alt="" class='transport-nationality-icon'>
              {{ transport.number !== '' ? transport.number : 'ГРЗ отсутствует' }}
              <div v-if='transport.trailer'>/</div>
              <img v-if='transport.trailer' :src="`${baseUrl}/img/icons/${transport.trailerNationality.iso2}.svg`" alt="" class='transport-nationality-icon'/>
              {{ transport.trailer !== '' ? ` ${transport.trailer}` : '' }}
            </div>
          </div>

        </div>

      </div>

    </div>

    <div v-if='currentTransport' class="transports">

      <transport-item
        :base-url='baseUrl'
        :transport='currentTransport'
        :visitor='visitor'
        :cfg-form-fields='cfgFormFields'
        :cfg-menu-visitor='cfgMenuVisitor'
        :cfg-menu-transport='cfgMenuTransport'
        @issue-pass="(transport) => $emit('issue-pass', transport)"
        @change-transport-access="(transport) => $emit('change-transport-access', transport)"
        @give-pdf-pass="(isGivePassPeriod, printPermanentAsOne) => $emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne, currentTransportIndex)"
      />

    </div>

  </div>
</template>

<script>
import TransportItem from './TransportItem.vue';
export default {

  components: { TransportItem },

  props: {
    baseUrl: {
      type: String,
      required: true
    },

    transports: {
      type: Array,
      required: true
    },

    currentTransportIndex: {
      type: Number
    },

    isApplicationAuto: {
      type: Boolean
    },

    cfgMenuVisitor: {
      type: Object
    },

    cfgMenuTransport: {
      type: Object
    },

    cfgFormFields: {
      type: Object,
      required: true
    },

    visitor: {
      type: Object
    },

    tabTitle: {
      type: Function
    }
  },

  computed: {
    currentTransport() {
      return this.transports[this.currentTransportIndex]
    }
  },

  watch: {
    transports() {
      this.currentTransportIndex = null
    }
  },

  methods: {
    selectTransport(index, documents) {
      this.$emit('select-transport', index, documents)
    }
  }
}
</script>

<style>
.transport-view {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.transport-view-header {
  height: 36px;
  display: flex;
  align-items: start;
  gap: 16px;
}

.transport-tab-text {
  display: flex;
  align-items: center;
  gap: 16px;
}

.transport-nationality-icon {
  width: 16px;
}

.transports{
  display: flex;
  flex-direction: column;
}

.transport-tabs {
  display: flex;
  align-items: center;
  flex: 1;
  overflow-x: auto;
}

.marquee {
  white-space: nowrap;
  overflow: hidden;
}

.marquee-inner {
  animation: marquee 8s linear infinite;
}

.application-auto-transport {
  grid-row: 1 / 2;
  grid-column: 1 / 2;
}

@keyframes marquee {
  from {
    transform: skewX(20deg) translateX(100%);
  }

  to {
    transform: skewX(20deg) translateX(-100%);
  }
}
</style>
